export default __webpack_public_path__ + "static/media/leaves-l.a48c752b.png";